import React from 'react';
import CountertopUniversityForm from '../../../features/common/countertop-university/components/CountertopUniversityForm';
import { CountertopUniversityProvider } from '../../../features/common/countertop-university/contexts/countertopUniversityContext';

export default function CountertopUniversityPage() {
    return (
        <React.Fragment>
            <div className={'content-block'}>
                <CountertopUniversityProvider>
                    <CountertopUniversityForm />
                </CountertopUniversityProvider>
            </div>
        </React.Fragment>
    )
}
